import Form from 'JS/form/Form';
import { notice } from 'JS/utils/notice';
import initScheduleBlockSlider from '../../components/schedule-slider/_index';

class PostsFilter {


    isAppend = false;

    routeString = '';

    constructor(formElement,  innerWrapper) {
        this.form = formElement;
        this.innerWrapper = innerWrapper;
        this.formInstance  = new Form(this.form);
        this.btnMore = document.querySelector('[data-btn-more]');
        this.params = '';
        this.formAttr = this.form.dataset.filterCourse;
        this.scheduleSlider = document.querySelector('.schedule-slider') ? document.querySelector('.schedule-slider') : null;
        this.btnReset = this.form.querySelector('[data-reset-filter]');
        this.init();
    }

    init() {
        this.addListeners();
    }

    addListeners() {
        this.formInstance.on('change', (data) => {
            if (!this.isAppend) {
                data.paged = 1;
                this.resetPagination();
            }

            this.formSumbit(data);
        });

        this.btnReset.addEventListener('click', () => {
            this.formInstance.reset();
        })

        if (this.btnMore) {
            this.btnMore.addEventListener('click', () => {
                this.paginationHandler();
            });
        }
    }

    prepareData(data) {
        this.params = new URLSearchParams({
            data: JSON.stringify(data),
        }).toString();
    }

    responseDataSchedule(data) {
        if (data.data.posts_html !== '') {
            this.innerWrapper.innerHTML = data.data.posts_html;
        } else {
            this.innerWrapper.innerHTML = '<h2 class="archive-page__title-empty">Здесь ничего нет!</h2>';
        }
    }

    responseDataArchive(data) {
        if (data.data.posts_html !== '') {
            this.btnMore.style.display = 'block';
            this.isAppend ? this.innerWrapper.insertAdjacentHTML('beforeend', data.data.posts_html) : this.innerWrapper.innerHTML = data.data.posts_html;
        } else {
            this.innerWrapper.innerHTML = '<h2 class="archive-page__title-empty">Здесь ничего нет!</h2>';
            this.btnMore.style.display = 'none';
        }

        this.isAppend = false;
    }

    buttonShowOrHide(data) {
        if (data.data.more_posts_num <= 0) {
            this.btnMore.style.display = 'none';
        } else {
            return;
        }
    }

    checkRouteStr() {
        if (this.formAttr === 'course' || this.formAttr === 'schedule') {
            this.routeString = `${backendData.restUrl}hml/v1/courses?${this.params}`;
        } else {
            this.routeString = `${backendData.restUrl}hml/v1/trips?${this.params}`;
        }
    }

    updateSliderSchedule() {
        if (!this.scheduleSlider.swiperInstance) {
            return;
        }
        
        this.scheduleSlider.inited = false;
        this.scheduleSlider.swiperInstance.destroy();
        initScheduleBlockSlider();

        this.scheduleSlider = document.querySelector('.schedule-slider') ? document.querySelector('.schedule-slider') : null;
        this.sliderNav = this.scheduleSlider.querySelector('.schedule-slider__buttons');
     
        if (this.scheduleSlider.swiperInstance.slides.length <= 3) {
            this.sliderNav.style.display = 'none';
        } else {
            this.sliderNav.style.display = 'flex';
        }
    }

    formSumbit(data) {
        this.prepareData(data);

        this.checkRouteStr();

        window.fullscreenLoader.active = true;
        
        fetch(this.routeString)
        .then((res) => res.json())
        .then((data) => {
            if (data.success) {
                if (!this.scheduleSlider) {
                    this.responseDataArchive(data);
                    this.buttonShowOrHide(data);
                } else {
                    this.responseDataSchedule(data);
                    this.updateSliderSchedule();
                }
            } else {
                notice(data.data?.message, 'error');
            }
            
        })
        .catch((error) => {
            console.log(error);
            notice(error, 'error');
        })
        .finally(() => {
            window.fullscreenLoader.active = false;
        })
    }

    resetPagination() {
        const pagedInp = this.formInstance.fields.find(f => f.name === 'paged');

        if (!pagedInp) {
            return;
        }

        pagedInp._value = 1;
    }
    
    paginationHandler() {
        const pagedInp = this.formInstance.fields.find(f => f.name === 'paged');

        if (!pagedInp) {
            return;
        }

        this.isAppend = true;
        pagedInp.value = Number(pagedInp.value) + 1;
    }
}

const postFilters = document.querySelectorAll('[data-filter-course]');

postFilters.forEach(filter => {
    if (!filter) return;
    
    const wrapper = document.querySelector('.block-course-grid') ? document.querySelector('.block-course-grid') : document.querySelector('.schedule-slider__wrapper');

    new PostsFilter(filter, wrapper);
});